import React, {Component} from 'react';
import moment from 'moment';
import {withRouter} from 'react-router-dom';
import {autobind} from 'core-decorators';
import {formatMoney} from 'core/utils';
import {reverse} from 'core/urls';
import EmptyMessage from 'components/empty-message';
import styles from './styles.css';

@withRouter
@autobind
export default class CreditHistory extends Component {
    handleUserClick(id) {
        return () => this.props.history.push(reverse('orderDetail', {id}));
    }

    render() {
        if (this.props.transactions.length === 0) return <EmptyMessage />;

        return (
            <table className={styles.root}>
                <thead className={styles.header}>
                    <tr>
                        <th>Fecha</th>
                        <th>Detalle</th>
                        <th>Monto</th>
                    </tr>
                </thead>
                <tbody className={styles.body}>
                    {this.props.transactions.map(transaction => (
                        <tr
                            key={transaction.id}
                            className={transaction.orderLog.order && styles.clickable}
                            onClick={transaction.orderLog.order && this.handleUserClick(transaction.orderLog.order.id)}>
                            <td>
                                <span className={styles.mobileOnly}>Fecha:</span>
                                {moment(transaction.date).format('DD/MM/YYYY')}
                            </td>
                            <td>
                                <span className={styles.mobileOnly}>Detalle:</span>
                                {transaction.description}
                            </td>
                            <td>
                                <span className={styles.mobileOnly}>Monto:</span>
                                {formatMoney(transaction, 'amount')}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    }
}



// WEBPACK FOOTER //
// ./components/credit-history/index.js